import * as React from 'react';
import { View, IconButton, rem, CenterButton, Touchable } from '../libs/WebComponents';

export interface AnswerListItemType{
   value: string
   label: string
   A?: boolean
   B?: boolean
   C?: boolean
}

const AnswersSelectList = (props: {message: string, type: 'A' | 'B' | 'C', allAnswers: AnswerListItemType[], changeAnswers: Function, closePopup: Function}) => {

   const [answers, setAnswers] = React.useState<AnswerListItemType[]>(props.allAnswers.filter(answer=>answer[props.type] || (!answer.A && !answer.B && !answer.C)));
   const [new_answers, setNewAnswers] = React.useState<AnswerListItemType[]>([]);
   const [other_answer, setOtherAnswer] = React.useState('');
   const _toggleAnswer = React.useCallback(({value}) => {
      setAnswers(answers =>answers.map(answer=>{
         if (answer.value===value) return {...answer, [props.type]:!answer[props.type]};
         return answer;
      }));
   },[answers]);

   const _changeAnswers = () => {
      const added_answers: string[] = [];
      const removed_answers: string[] = [];
      answers.map((answer)=>{
         if (answer[props.type]) added_answers.push(answer.value);
         if (!answer[props.type]) removed_answers.push(answer.value);
      });
      props.changeAnswers(props.type, [...new_answers], [...added_answers], [...removed_answers]);
      props.closePopup()
   }

   const _changeOtherAnswer = React.useCallback((e: any) => {
      setOtherAnswer(e.target.value ? e.target.value : '');
   },[]);


   const _addOtherAnswer = () => {
      const answer: AnswerListItemType = {value:other_answer, label:other_answer};
      if (answers[0].hasOwnProperty('A')) answer.A = false;
      if (answers[0].hasOwnProperty('B')) answer.B = false;
      if (answers[0].hasOwnProperty('C')) answer.C = false;
      answer[props.type] = true;
      setAnswers((an)=>[...an, answer]);
      setNewAnswers((an)=>[...an, answer]);
      setOtherAnswer('');
   };

   return (
   <View className={'popup-content'}>
      <h3>{props.message}</h3>
      <small>Je kunt geen, één of meerdere woorden kiezen die jij van toepassing vindt.</small>
      
      <View className={'answer-boxes'}>
         <View className={'answer-box'}>
         <View className={'answers-list'}>
               <ul className={answers.length>10?'columns-2':''}>
                  {answers.map((answer: AnswerListItemType)=><li className={'answers-list-item'} key={answer.value}><Touchable onPress={()=>_toggleAnswer(answer)}>{answer.label}<IconButton name={'Close'} size={rem(2.2)} iconSize={rem(2)} iconColor={answer[props.type]?null:'var(--color-white)'} color={answer[props.type]?'var(--color-green)':'var(--color-white)'}/></Touchable></li>)}
               </ul>
            </View>
         </View>
      </View>
      <View style={{flexDirection:'row',alignItems:'center',maxWidth:rem(40),margin:'0 auto',paddingLeft:rem(2)}}>
         <input type="text" placeholder="Jouw woord" className={'form-control'} onChange={_changeOtherAnswer} value={other_answer}/>
         <IconButton name={'Plus'} onPress={_addOtherAnswer} size={rem(3.5)} iconSize={rem(4)} color={'var(--color-white)'} iconColor={'var(--color-purple)'} containerStyle={{display:'flex', marginLeft:rem(1),opacity:other_answer?1:.3}}/>
      </View>
      <View className={'question-submit-box'}>
         <CenterButton iconName={'Close'} onPress={props.closePopup} size={rem(3)} iconSize={rem(2.5)} color={'var(--bs-body-color)'} iconColor={'var(--color-white)'} labelText={'Annuleer/sluit'} textStyle={{fontSize:rem(1.2), marginTop:rem(-.5), color:'var(--color-white)'}} style={{display:'flex',maxWidth:rem(10),marginTop:rem(3)}}/>
         <IconButton name={'Check'} onPress={_changeAnswers} size={rem(6)} iconSize={rem(5)} color={'var(--color-green)'} iconColor={'var(--color-purple-dark)'} containerStyle={{display:'flex', marginLeft:rem(1)}}/>
      </View>
   </View>
   );
};

export default React.memo(AnswersSelectList);